"use client";

import { useState } from "react";
import SectionContainer from "@/common/SectionContainer";
import AnimatedContent from "@/components/AnimatedContent";
import KakaoMap from "./components/KakaoMap";
import CtlTable from "./components/CtlTable";
import { useGetCtlMap } from "@/api/useGetCtlMapApi";
import { CTL_SECTION_DESCRIPTION, CTL_SECTION_TITLE } from "./constants";

const CtlClient = () => {
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const { data, isLoading } = useGetCtlMap();
  const branches = data?.data?.list ?? [];

  return (
    <SectionContainer
      id="ctl-section"
      className="section-shell bg-white text-gray-900"
    >
      <AnimatedContent className="section-inner section-stack">
        <div className="section-head">
          <h2 className="section-title">{CTL_SECTION_TITLE}</h2>
          <p className="caption text-gray-600 section-lead">
            {CTL_SECTION_DESCRIPTION}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="rounded-2xl overflow-hidden border border-slate-200 bg-white shadow-sm min-h-[400px] lg:min-h-[600px]">
            <KakaoMap
              branches={branches}
              selectedId={selectedId}
              onSelect={setSelectedId}
            />
          </div>

          <div className="h-full min-h-[400px] lg:min-h-[600px]">
            <CtlTable
              branches={branches}
              isLoading={isLoading}
              selectedId={selectedId}
              onSelect={setSelectedId}
            />
          </div>
        </div>
      </AnimatedContent>
    </SectionContainer>
  );
};

export default CtlClient;
